import { render, staticRenderFns } from "./ExpensesSection.vue?vue&type=template&id=09ca87e8&scoped=true&"
import script from "./ExpensesSection.vue?vue&type=script&lang=js&"
export * from "./ExpensesSection.vue?vue&type=script&lang=js&"
import style0 from "./ExpensesSection.vue?vue&type=style&index=0&id=09ca87e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ca87e8",
  null
  
)

export default component.exports